import { render, staticRenderFns } from "./SelectTournamentModal.vue?vue&type=template&id=2c4d88c3&scoped=true"
import script from "./SelectTournamentModal.vue?vue&type=script&lang=js"
export * from "./SelectTournamentModal.vue?vue&type=script&lang=js"
import style0 from "./SelectTournamentModal.vue?vue&type=style&index=0&id=2c4d88c3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c4d88c3",
  null
  
)

export default component.exports